import { MULTIPLE_KEY } from '@web-platform/shared-universal-constants/src/carrierTypes';

import type { CarriersFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/carriers';

export const NONE_INTENT_KEY = '__noneIntent';

export const buildNoneIntentInitialState = (): CarriersFilterState => ({
  [NONE_INTENT_KEY]: { value: true },
  [MULTIPLE_KEY]: { value: false },
});
